import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { onMounted, onUnmounted } from 'vue';
    import { getConfig, AppConfig } from '@/services/config';
    import { WidgetId, WindowWithCaptcha } from './interfaces';

    const scriptId = '_SMART_CAPTCHA_';

    // ИД контейнера, где должна быть капча
    const containerId = 'smart-captcha-container';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'VueSmartcaptcha',
  emits: [
        'success',
        'network-error',
        'challenge-hidden',
        'challenge-visible'
    ],
  setup(__props, { emit: __emit }) {

    const emit = __emit;

    // Получить настройки конфигурации приложения
    const config: AppConfig = getConfig();

    // ИД скрипта
    let widgetId: WidgetId; // ИД виджета капчи

    // Чтобы все работало, нам нужно два дополнительных поля: smartCaptcha и onSmartCaptchaLoaded
    // smartCaptcha нам заполнит Яндекс объектом, через который мы будем взаимодействовать с АПИ
    // onSmartCaptchaLoaded мы заполним сами, его вызовет Яндекс, когда нужно будет инициализировать
    // АПИ параметрами
    const windowWithCaptcha: WindowWithCaptcha = window;

    // Обработчик события загрузки скриптов капчи
    function onSmartCaptchaLoaded(): void {
        if (!windowWithCaptcha.smartCaptcha) {
            return;
        }

        renderCaptcha();
        subscribeHandlers();
    }

    // Прикрепить <script> с капчей
    function addSmartCaptchaScript(): void {
        const script = document.createElement('script');
        script.id = scriptId;
        script.src = 'https://smartcaptcha.cloud.yandex.ru/captcha.js?render=onload&onload=onSmartCaptchaLoaded';
        script.async = true;
        script.defer = true;

        document.head.appendChild(script);
    }

    // Подписать обработчики для передачи событий капчи через события vue
    function subscribeHandlers(): void {
        windowWithCaptcha.smartCaptcha?.subscribe(
            widgetId,
            'success',
            (token: string) => setCaptchaTokenToFormInput(token)
        );
        windowWithCaptcha.smartCaptcha?.subscribe(
            widgetId,
            'network-error',
            () => emit('network-error')
        );
        windowWithCaptcha.smartCaptcha?.subscribe(
            widgetId,
            'challenge-visible',
            () => emit('challenge-visible')
        );
    }

    function setCaptchaTokenToFormInput(token: string) {
        const tokenInput = document.getElementById('smart-captcha-token') as HTMLInputElement;
        if (tokenInput) {
            tokenInput.setAttribute('data-valid-token', 'true');
            tokenInput.value = token;
        }
    }

    // Вызвать отрисовку капчи
    function renderCaptcha(): void {
        if (windowWithCaptcha.smartCaptcha) {
            widgetId = windowWithCaptcha.smartCaptcha.render(containerId, {
                sitekey: config.SmartCaptchaSiteKey,
                hl: 'ru'
            });
        }
    }

    onMounted(() => {
        if (!document.getElementById(scriptId)) {
            addSmartCaptchaScript();
        }

        if (windowWithCaptcha.smartCaptcha) {
            renderCaptcha();
            subscribeHandlers();
            return;
        }

        windowWithCaptcha.onSmartCaptchaLoaded = onSmartCaptchaLoaded;
    });


    onUnmounted(() => {
        windowWithCaptcha.smartCaptcha?.destroy(widgetId);
    });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", { id: containerId }))
}
}

})